import React from "react";
import { Box, Typography } from "@mui/material";
import { RED, TEXT_BLACK, TEXT_MUTED } from "../../utils/designTokens";

interface BrandPanelProps {
  logoWidth?: number;
  responsive?: boolean;
}

const BrandPanel: React.FC<BrandPanelProps> = ({
  logoWidth = 220,
  responsive = false,
}) => (
  <Box
    sx={{
      flex: 1,
      p: responsive ? { xs: 3, md: 6 } : 6,
      pr: responsive ? { xs: 3, md: 4 } : 4,
      background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: responsive ? { xs: "center", md: "flex-start" } : undefined,
      textAlign: responsive ? { xs: "center", md: "left" } : undefined,
      borderRight: responsive
        ? { xs: "none", md: "1px solid rgba(0,0,0,0.06)" }
        : "1px solid rgba(0,0,0,0.06)",
    }}
  >
    <img
      src="/worldlinklogo.svg"
      alt="Worldlink"
      style={{ width: logoWidth, marginBottom: 24 }}
    />
    <Typography
      sx={{
        fontSize: responsive ? { xs: "1.8rem", md: "2.4rem" } : "2.8rem",
        fontWeight: 900,
        color: TEXT_BLACK,
        lineHeight: 1.05,
        mb: responsive ? { xs: 2, md: 3 } : 3,
      }}
    >
      Supply Chain Intelligence Platform
    </Typography>
    <Box
      sx={{
        width: 80,
        height: 4,
        background: RED,
        borderRadius: 6,
        mb: responsive ? { xs: 1.5, md: 2 } : 2,
      }}
    />
    <Typography
      sx={{
        fontSize: responsive ? { xs: "0.9rem", md: "1rem" } : "1rem",
        fontWeight: 500,
        color: TEXT_MUTED,
        lineHeight: 1.6,
        maxWidth: responsive ? { xs: 260, md: 360 } : 360,
      }}
    >
      Visibility that keeps your global network connected.
    </Typography>
  </Box>
);

export default BrandPanel;
